import ACTION_CONSTANTS from '../../constants/actionConstants';

const initialState = {
  pendingNavigation: null,
  pendingHistoryAction: null,
};

export default function navigationReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_CONSTANTS.NAVIGATE_TO:
      return {
        ...state,
        pendingNavigation: action.payload.navigation,
        pendingHistoryAction: null,
      };
    case ACTION_CONSTANTS.NAVIGATE_BACK:
    case ACTION_CONSTANTS.NAVIGATE_FORWARD:
      return {
        ...state,
        pendingNavigation: null,
        pendingHistoryAction: {
          type: action.type,
          steps: action.payload.steps,
        },
      };
    case ACTION_CONSTANTS.CLEAR_NAVIGATION:
      return {
        ...state,
        pendingNavigation: null,
        pendingHistoryAction: null,
      };
    default:
      return state;
  }
}
